import { Modal } from './Modal.js';

interface ConfirmDialogProps {
  open: boolean;
  title: string;
  message: string;
  confirmLabel?: string;
  confirmColor?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export function ConfirmDialog({ open, title, message, confirmLabel = 'Confirm', confirmColor, onConfirm, onCancel }: ConfirmDialogProps) {
  return (
    <Modal open={open} onClose={onCancel} title={title} width={400}>
      <div style={{ padding: '0 24px 24px' }}>
        <p style={{ fontSize: 14, color: 'var(--t2)', lineHeight: 1.6, marginBottom: 20 }}>{message}</p>
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
          <button className="btn-sm btn-ghost" onClick={onCancel}>Cancel</button>
          <button
            className="btn-sm btn-primary"
            style={confirmColor ? { background: confirmColor, boxShadow: 'none' } : undefined}
            onClick={onConfirm}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </Modal>
  );
}
